module.exports = __webpack_public_path__ + "img/sponsorN31.ee1bfe48.png";